import { z } from 'zod';

export const areaRelatorioSchema = z.enum(['credito', 'fundiario', 'ambiental']);

export const relatorioGestaoSchema = z.object({
  id: z.string(),
  area: areaRelatorioSchema,
  titulo: z.string(),
  data_base: z.string(),
  periodo: z.enum(['diario', 'semanal']).default('diario'),
  resumo_semanal: z.boolean().default(false),
  agente: z.string(),
  nome_arquivo: z.string(),
  mime: z.string(),
  tamanho: z.coerce.number(),
  criado_em: z.string(),
  download_url: z.string(),
});

export const relatoriosGestaoSchema = z.array(relatorioGestaoSchema);
export type AreaRelatorio = z.infer<typeof areaRelatorioSchema>;
export type RelatorioGestao = z.infer<typeof relatorioGestaoSchema>;
